<div class="row">
  <div class="col"></div>
  <div class="col">
    <google-signin-button></google-signin-button>
  </div>
  <div class="col"></div>
</div>